import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox, FormControlLabel, IconButton, Stack, Typography } from '@mui/material';

import { MultiUpload } from 'components/Form';
import { IconWrapper } from 'components/Icon';

import { maxFileSizeMb, maxFiles, maxUploadSizeMb } from '../validation';

export const idsNotIn = (files = [], keptIds = []) =>
  files.filter((file) => !keptIds.includes(file.file_id)).map((file) => file.file_id);

const attachmentsHelperText = `Up to ${maxFiles} files, at most ${maxFileSizeMb} MB each and ${maxUploadSizeMb} MB in total`;

const KeptFiles = ({ name }) => {
  const { watch, setValue } = useFormContext();
  const files = watch(name) ?? [];

  const remove = (fileId) =>
    setValue(
      name,
      files.filter((file) => file.file_id !== fileId),
      { shouldValidate: true }
    );

  return files.map((file) => (
    <Stack key={file.file_id} direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
        {file.name}
      </Typography>
      <IconButton
        size="small"
        aria-label={`Remove ${file.name}`}
        onClick={() => remove(file.file_id)}
      >
        <IconWrapper icon="xMark" sx={{ svg: { width: 16, height: 16 } }} />
      </IconButton>
    </Stack>
  ));
};

export const AttachmentsField = ({ keptName }) => (
  <Stack gap={1}>
    <Typography variant="body2" fontWeight={600}>
      Attachments
    </Typography>
    {keptName && <KeptFiles name={keptName} />}
    <MultiUpload name="files" helperText={attachmentsHelperText} />
  </Stack>
);

export const PublishQuestionFilesField = ({ name, files }) => {
  const { watch, setValue } = useFormContext();
  const selected = watch(name) ?? [];

  if (!files?.length) return null;

  const toggle = (fileId) =>
    setValue(
      name,
      selected.includes(fileId) ? selected.filter((id) => id !== fileId) : [...selected, fileId]
    );

  return (
    <Stack>
      <Typography variant="body2" fontWeight={600}>
        Question attachments
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Untick files that shouldn't be published to other suppliers. The asking supplier always sees
        them.
      </Typography>
      {files.map((file) => (
        <FormControlLabel
          key={file.file_id}
          control={
            <Checkbox
              checked={selected.includes(file.file_id)}
              onChange={() => toggle(file.file_id)}
            />
          }
          label={file.name}
        />
      ))}
    </Stack>
  );
};
